export const RECEIVE_ACCESS_TOKEN = "RECEIVE_ACCESS_TOKEN";
export const RECEIVE_REFRESH_TOKEN = "RECEIVE_REFRESH_TOKEN";
export const RECEIVE_ID_TOKEN = "RECEIVE_ID_TOKEN";
export const RECEIVE_PROFILE_DATA = "RECEIVE_PROFILE_DATA";
export const RECEIVE_USER_PROFILE_DATA = "RECEIVE_USER_PROFILE_DATA";
export const LOGOUT = "LOGOUT";